module.exports = __webpack_public_path__ + "img/geolocation.8c4aad2e.png";